import Vue from 'vue';
import { BlockDTO } from '../../../model/BlockDTO';
import { InstanceType } from '../../../enums/InstanceType';

export async function apartmentLocationDetailsData(context: Vue, block: BlockDTO) {
	let [projectGallery, constructionGallery, surroundingsGallery] = await Promise.all([
		context.$resourceService.fetchImages(block.id, "project-gallery", {
			...context.$store.boIdMapping
		}),
		context.$resourceService.fetchImages(block.id, "construction-gallery", {
			...context.$store.boIdMapping,
			[InstanceType.ApartmentLocation]: context.$route.params.locationCatalogNumber,
			[InstanceType.ConstructionPhase]: context.$route.params.locationCatalogNumber + "_1",	// simplified, but probably sufficient; TODO check if it's enough
		}),
		context.$resourceService.fetchImages(block.id, "surroundings-gallery", {
			...context.$store.boIdMapping
		}),
	]);

	return {
		projectGallery,
		constructionGallery,
		surroundingsGallery
	};
}
